export const sounds = {
  'SOUND:load|regular': [
    {
      play: 'main_ambient',
      loop: true,
      volume: .6,
    },
    {
      play: 'main_music',
      loop: true,
      volume: .7,
    },
  ],
  'SOUND:load|freespins': [
    {
      play: 'free_spin_music',
      volume: .4,
      fade: .6,
      loop: true,
    },
    {
      play: 'free_spin_ambient',
      volume: .6,
      fade: .8,
      loop: true,
    },
  ],
  'BUTTON:close': [
    {
      play: 'tap_to_play',
      volume: .8,
    },
  ],
  'RADIO:loss': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:win': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:turbo': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:left': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:PrevAutoPage': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:NextAutoPage': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BET:bet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'SOUND:carousel': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:startFreespin': [
    { stop: 'main_ambient' },
    { stop: 'main_music' },
    {
      play: 'free_spin_music',
      volume: .4,
      fade: .6,
      loop: true,
    },
    {
      play: 'free_spin_ambient',
      volume: .6,
      fade: .8,
      loop: true,
    },
    {
      play: 'free_spin_start',
      volume: .3,
    },
  ],
  'STATE:OUT:FS-END': [
    { stop: 'free_spin_ambient' },
    { stop: 'free_spin_music' },
    {
      play: 'main_ambient',
      loop: true,
      volume: .6,
    },
    {
      play: 'main_music',
      loop: true,
      volume: .7,
    },
  ],
  'BUTTON:prevbet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:nextbet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:maxbet': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:prevauto': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:nextauto': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'BUTTON:maxauto': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|paytable': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|gamerules': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|history': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'RADIO:menu|settings': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'SOUND:ui': [
    {
      play: 'outside_buttons',
      volume: .4,
    },
  ],
  'SOUND:spin-btn:turbo': [
    {
      play: 'button_spin',
      volume: .7,
    },
  ],
  'TOGGLE:intro|true': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:intro|false': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:space|true': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'TOGGLE:space|false': [
    {
      play: 'inside_buttons',
      volume: .3,
    },
  ],
  'SOUND:reels-spin:turbo': [
    {
      play: 'reel_spin',
      loop: true,
      fade: .2,
      volume: .3,
    },
  ],
  'SOUND:REEL-STOP': [
    {
      play: 'reel_stop_{n}',
      random: [1, 5],
      volume: 1,
    },
  ],
  'REELS-STOP': [{ stop: 'reel_spin' }],
  'SOUND:win:regular': [
    {
      play: 'regular_win',
      volume: .7,
    },
  ],
  'SOUND:win:big': [
    {
      play: 'big_win',
      volume: .8,
    },
  ],
  'SOUND:win:mega': [
    {
      play: 'mega_win',
      volume: .9,
    },
  ],
  'SOUND:win:ultra': [
    {
      play: 'ultra_win',
      volume: .8,
    },
  ],
  'SOUND:win:multiply': [
    {
      play: 'x2_win',
      volume: .8,
    },
  ],
  'STATE:IN:FB-ADD': [
    {
      play: 'free_bet_big_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:big': [
    {
      play: 'free_bet_big_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:ultra': [
    {
      play: 'free_bet_ultra_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:mega': [
    {
      play: 'free_bet_mega_win',
      volume: .7,
    },
  ],
  'FREEBET:TOTAL-WIN:total': [
    {
      play: 'free_bet_total_win',
      volume: .7,
    },
  ],
}

export const delays = {
  regular: .2,
  turbo: .1,
}

export const wins = []
